import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=46f3b7c4&scoped=true"
import script from "./attribute.vue?vue&type=script&lang=js"
export * from "./attribute.vue?vue&type=script&lang=js"
import style0 from "./attribute.vue?vue&type=style&index=0&id=46f3b7c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3b7c4",
  null
  
)

export default component.exports